<template>
  <div class="container">
    <BaseFrame
    clearText=''
    :submitText="haveButton ? '保存' : ''"
    @submit='submit'
    @clear="onCancel"
    >
      <div slot="content">
        <lk-form
          :model="orderInfo"
          label-position="right"
          :label-width="130"
          ref="orderInfo.saleRecallPlan"
        >
          <div class="cardContainer">
            <lk-card title="订单信息">
              <lk-row :gutter="16">
                <lk-col span="7">
                  <lk-form-item label="订单编号:">
                    <span >{{orderInfo.orderCode}}</span>
                  </lk-form-item>
                </lk-col>
                <lk-col span="7">
                  <lk-form-item label="创建日期:">
                    <span >{{createTime}}</span>
                  </lk-form-item>
                </lk-col>
              </lk-row>
            </lk-card>
          </div>
          <div class="content">
            <lk-card title="商品信息">
                <lk-table border :columns='columns' :data='tableData'></lk-table>
            </lk-card>
          </div>
          <div class="content">
            <lk-card title="收货信息">
              <lk-row :gutter="16">
                <lk-col span="7">
                  <lk-form-item label="联系人:">
                    <span>{{orderInfo.address.consigneeName || ''}}</span>
                  </lk-form-item>
                </lk-col>
                <lk-col span="7">
                  <lk-form-item label="联系电话:">
                    <span>{{orderInfo.address.consigneePhone || ''}}</span>
                  </lk-form-item>
                </lk-col>
              </lk-row>
              <lk-row :gutter="16">
                <lk-col span="7">
                  <lk-form-item label="收货地址:">
                    <span>{{`${orderInfo.address.provinceName}${orderInfo.address.cityName}${orderInfo.address.district}${orderInfo.address.address}`}}</span>
                  </lk-form-item>
                </lk-col>
              </lk-row>
            </lk-card>
          </div>
          <div class="content">
            <lk-card title="发票信息">
              <lk-row :gutter="16">
                <lk-col span="7">
                  <lk-form-item label="名称:">
                    <span>{{ orderInfo.invoice.companyName }}</span>
                  </lk-form-item>
                </lk-col>
                <lk-col span="7">
                  <lk-form-item label="税号:">
                    <span>{{ orderInfo.invoice.dutyParagraph }}</span>
                  </lk-form-item>
                </lk-col>
                <lk-col span="7">
                  <lk-form-item label="单位地址:">
                    <span>{{ orderInfo.invoice.companyAddress }}</span>
                  </lk-form-item>
                </lk-col>
                <lk-col span="7">
                  <lk-form-item label="电话号码:">
                    <span>{{ orderInfo.invoice.phone }}</span>
                  </lk-form-item>
                </lk-col>
                <lk-col span="7">
                  <lk-form-item label="开户行:">
                    <span>{{ orderInfo.invoice.bank }}</span>
                  </lk-form-item>
                </lk-col>
                <lk-col span="7">
                  <lk-form-item label="银行账户:">
                    <span>{{ orderInfo.invoice.bankAccount }}</span>
                  </lk-form-item>
                </lk-col>
              </lk-row>
            </lk-card>
          </div>
          <div class="content">
            <lk-card title="配送信息">
              <lk-row :gutter="16">
                <lk-col span="7">
                  <lk-form-item label="发货人:">
                    <lk-select v-if="canEdit" v-model='orderInfo.deliverer' class="item" clearable>
                      <lk-option v-for="(item, index) in deliverList" :key="index" :value="item.id">{{item.name}}</lk-option>
                    </lk-select>
                    <span v-else>{{ orderInfo.deliverName }}</span>
                  </lk-form-item>
                </lk-col>
                <lk-col span="7">
                  <lk-form-item label="发货人联系方式:">
                    <lk-input v-if="canEdit" v-model="orderInfo.deliverMobile"></lk-input>
                    <span v-else>{{ orderInfo.deliverMobile }}</span>
                  </lk-form-item>
                </lk-col>
                <lk-col span="7">
                  <lk-form-item label="配送方式:">
                    <span>{{ orderInfo.deliverMethod || '物流配送' }}</span>
                  </lk-form-item>
                </lk-col>
              </lk-row>
              <lk-row :gutter="16">
                <lk-col span="7">
                  <lk-form-item label="运单号:">
                    <lk-input v-if="canEdit" v-model="orderInfo.deliverNo"></lk-input>
                    <span v-else>{{ orderInfo.deliverNo }}</span>
                  </lk-form-item>
                </lk-col>
              </lk-row>
            </lk-card>
          </div>
        </lk-form>
      </div>
    </BaseFrame>
  </div>
</template>

<script>
import BaseFrame from '@/components/frame/BaseFrame.vue';
import toolsService from '../../../services/lgq/services';
import utils from '../../../libs/utils';
import system from '../../../services/system';
import DtpInputNumber from '../../../components/DtpInputNumber';

export default {
  name: 'saleOrderInfo',
  components: {
    BaseFrame,
  },
  computed: {
    canEdit() {
      return this.$route.name === 'saleOrderInfoEdit';
    },
    haveButton() {
      return ['saleOrderInfoEditRefund', 'saleOrderInfoEdit'].includes(this.$route.name);
    },
    createTime() {
      return utils.formatDateToSecond(this.orderInfo.createTime);
    },
  },
  data() {
    return {
      deliverList: [],
      id: '',
      infosArr: [],
      showClear: false,
      able: true,
      orderInfo: {
        address: {},
        invoice: {},
      },
      columns: [
        {
          title: '行号', width: 80, type: 'index',
        },
        { title: '商品编码', key: 'serialCode', minWidth: 116 },
        { title: '商品通用名', key: 'approvedName', minWidth: 116 },
        { title: '商品名', key: 'goodsName', minWidth: 116 },
        { title: '规格', key: 'spec', minWidth: 116 },
        { title: '销售数量', key: 'num', minWidth: 116 },
        { title: '含税价格', key: 'amount', minWidth: 116 },
        { title: '不含税价格', key: 'amountWithoutTax', minWidth: 116 },
        { title: '税额', key: 'tax', minWidth: 116 },
        { title: '单价', key: 'price', minWidth: 116 },
        {
          title: '税率',
          key: 'outputTaxRate',
          minWidth: 116,
          render: (h, params) => h('span', `${params.row.outputTaxRate}%`),
        },
        { title: '生产厂商', key: 'producer', minWidth: 116 },
      ],
      tableData: [],
      ruleValidate: {
        supplierStoreId: [
          {
            required: true, message: '请选择召回机构', trigger: 'change', type: 'number',
          },
        ],
        recallReason: [
          { required: true, message: '请输入召回原因', trigger: 'blur' },
        ],
      },
    };
  },
  methods: {
    clearModal() {
      this.modalTableData = [];
    },
    getInfo() {
      toolsService.saleOrderInfo({ orderId: this.$route.params.id }).then((res) => {
        if (res.data.status === 200) {
          this.orderInfo = res.data.data;
          this.tableData = this.orderInfo.details;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getDelivererList() {
      const params = { status: 1, page: 1, size: 1000 };
      system.storeUserList(params)
        .then((res) => {
          if (res.data.status === 200) {
            res.data.data.list.forEach((item) => {
              const { id, name } = item.sysUser;
              this.deliverList.push({ id, name });
            });
          } else {
            this.$Message.error(res.data.error);
          }
        })
        .catch((err) => {
          utils.handleError(err);
        });
    },
    submit() {
      if (this.$route.name === 'saleOrderInfoEdit') {
        this.saveEdit();
      } else {
        this.saveRefund();
      }
    },
    is11() {
      const regex = /^1[3-9]\d{9}$/;
      return regex.test(this.orderInfo.deliverMobile);
    },
    saveEdit() {
      if (!this.orderInfo.deliverer) {
        this.$Message.error('请选择发货人');
        return;
      }
      if (!this.orderInfo.deliverMobile || !this.is11()) {
        this.$Message.error('请正确填写发货人联系方式');
        return;
      }
      if (!this.orderInfo.deliverNo) {
        this.$Message.error('请填写运单号');
        return;
      }
      const delivererName = this.deliverList.filter(item => item.id === this.orderInfo.deliverer)[0].name;
      const params = {
        id: this.$route.params.id,
        deliverer: this.orderInfo.deliverer,
        deliverName: delivererName,
        deliverMobile: this.orderInfo.deliverMobile,
        deliverMethod: this.orderInfo.deliverMethod || '物流配送',
        deliverNo: this.orderInfo.deliverNo,
      };
      toolsService.saveOrderInfo(params)
        .then((res) => {
          if (res.data.status === 200) {
            this.$Message.success('保存成功');
            this.$router.go(-1);
          } else {
            this.$Message.error(res.data.error);
          }
        })
        .catch((err) => {
          utils.handleError(err);
        });
    },
    saveRefund() {
      const refundList = [];
      this.tableData.forEach((item) => {
        if (item.refundNum > 0) {
          refundList.push({ id: item.id, refundNum: item.refundNum });
        }
      });
      toolsService.refundDrug({ id: this.$route.params.id, details: refundList })
        .then((res) => {
          if (res.data.status === 200) {
            this.$Message.success('退货成功');
            this.$router.go(-1);
          } else {
            this.$Message.error(res.data.error);
          }
        })
        .catch((err) => {
          utils.handleError(err);
        });
    },
    onCancel() {
      this.$router.go(-1);
    },
  },
  created() {
    this.getDelivererList();
    this.getInfo();
    if (this.$route.name === 'saleOrderInfoEditRefund') {
      this.columns.splice(6, 0, {
        title: '退货数量',
        minWidth: 116,
        render: (h, { row, index }) => h(DtpInputNumber, {
          on: {
            'on-blur': (value) => {
              this.tableData[index].refundNum = value;
            },
          },
          props: {
            value: row.refundNum,
            placeholder: '数量',
            min: 0,
            precision: 2,
            max: row.num, // 可退数量
          },
        }),
      });
    } else {
      this.columns.splice(6, 0, { title: '退货数量', key: 'num', minWidth: 116 });
    }
  },
};
</script>

<style scoped lang="less">
 .content {
    padding: 16px 0px 16px 0px;
    padding-bottom: 0px;
  }
</style>
